import e from "./index31.js";
import { handleBreakpoints as t } from "./index33.js";
import n from "./index35.js";
import { createUnaryUnit as r, getValue as i } from "./index37.js";
import a from "./index39.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/borders/borders.js
function o(e) {
	return typeof e == "number" ? `${e}px solid` : e;
}
function s(e, t) {
	return n({
		prop: e,
		themeKey: "borders",
		transform: t
	});
}
var c = s("border", o), l = s("borderTop", o), u = s("borderRight", o), d = s("borderBottom", o), f = s("borderLeft", o), p = s("borderColor"), m = s("borderTopColor"), h = s("borderRightColor"), g = s("borderBottomColor"), _ = s("borderLeftColor"), v = s("outline", o), y = s("outlineColor"), b = (e) => {
	if (e.borderRadius !== void 0 && e.borderRadius !== null) {
		let n = r(e.theme, "shape.borderRadius", 4, "borderRadius");
		return t(e, e.borderRadius, (e) => ({ borderRadius: i(n, e) }));
	}
	return null;
};
b.propTypes = process.env.NODE_ENV === "production" ? {} : { borderRadius: e }, b.filterProps = ["borderRadius"], a(c, l, u, d, f, p, m, h, g, _, b, v, y);
//#endregion
export { b as borderRadius, o as borderTransform };

//# sourceMappingURL=index40.js.map